/**
 * Boat Choice Dialog Component
 * Speciale dialog voor het kiezen wat te doen met gekoppelde boten bij het verwijderen van een relatie
 */

import React from 'react';
import './ConfirmDialog.css';

interface BoatChoiceDialogProps {
  isOpen: boolean;
  message: string;
  onDeleteBoats: () => void;
  onSetUnknown: () => void;
  onCancel: () => void;
}

const BoatChoiceDialog: React.FC<BoatChoiceDialogProps> = ({
  isOpen,
  message,
  onDeleteBoats,
  onSetUnknown,
  onCancel,
}) => {
  if (!isOpen) return null;

  return (
    <div className="confirm-dialog-overlay" onClick={onCancel}>
      <div className="confirm-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="confirm-dialog-header">
          <h3>Gekoppelde Boten</h3>
        </div>
        <div className="confirm-dialog-body">
          <p>{message}</p>
          <p style={{ marginTop: '1rem', fontWeight: 500 }}>
            Wat wil je doen met de gekoppelde boten?
          </p>
        </div>
        <div className="confirm-dialog-footer" style={{ flexDirection: 'column', gap: '0.5rem' }}>
          <button
            className="btn-danger"
            onClick={onDeleteBoats}
            style={{ width: '100%' }}
          >
            Boten ook verwijderen
          </button>
          <button
            className="btn-primary"
            onClick={onSetUnknown}
            style={{ width: '100%' }}
          >
            Eigenaar op "Onbekend" zetten
          </button>
          <button
            className="btn-secondary"
            onClick={onCancel}
            style={{ width: '100%' }}
          >
            Annuleren
          </button>
        </div>
      </div>
    </div>
  );
};

export default BoatChoiceDialog;
